// confirmOnExit directive
// Copied from: http://stackoverflow.com/questions/14852802/detect-unsaved-changes-and-alert-user-using-angularjs


(function () {
    'use strict';

    angular
        .module('iMatApp')
        .directive('confirmOnExit', confirmOnExitDirective);

    function confirmOnExitDirective() {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                confirmOnExit: '&',
                confirmMessage: '@'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            window.onbeforeunload = function() {
                if (scope.confirmOnExit()) {
                    return scope.confirmMessage;
                }
            }

            var $locationChangeStartUnbind = scope.$on('$locationChangeStart', function (event, next, current) {
                if (scope.confirmOnExit()) {
                    if (!confirm(scope.confirmMessage)) {
                        event.preventDefault();
                    }
                }
            });

            scope.$on('$destroy', function () {
                window.onbeforeunload = null;
                $locationChangeStartUnbind();
            });
        }
    }
})();